import React, { useContext, useState, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';
import CryptoJS from 'crypto-js';
import Layout from '../../../Layout/index';
import Meal from '../../../Restau/Meal/Index';
import Restaurant from '../../../Restau/Restaurant/Index';
import Usermanager from './Usermanager';
import Users from '../../../Restau/UserManager/Users/Index';
import UsersManagement from '../../../Restau/UserManager/UserManagement/Index';
import Booking from '../../../Restau/Booking';
import Account from '../../../Restau/Account/components/Account/Index';
import Dashboard from '../../../Restau/Dashboard/Dashboard';
import ForgotPass from '../../../Account/ForgotPass';
import SignUp from '../../../Account/SignUp';
import { PermissionContext } from '../../../../context/PermissionContext';
import { AuthContext } from '../../../../context/AuthContext';
import ResForm from '../../../Account/ResForm';
import AccessDeniedPage from '../../../Restau/404';
import RequestList from '../../../Restau/Meal/component/Request/RequestList';
import RejectedRequest from '../../../Restau/Meal/component/RejectRequestTab/RejectedRequest';
import ApprovedAccount from '../../../Restau/Account/components/Approved';
import RequestAccount from '../../../Restau/Account/components/Request';
import RejectAccount from '../../../Restau/Account/components/Rejected';
// import Restaurant from '../../../Restaurant/Restaurant';


export default () => {
  // const [type, setType] = useState();
  const {
 statusCode, type, setType, setUserId, setStatusCode, setRestaurantId, userid, restaurantid,
} = useContext(AuthContext);
  
  const location = useLocation();
  
  const { permissionsAccess } = useContext(PermissionContext);

  // useEffect(() => {
  //     // Decrypt and retrieve the user ID from localStorage only once when the component mounts
  //     const encryptedData = localStorage.getItem('resuserid');
  //     const encryptedStatusCode = localStorage.getItem('resstatuscode');
  //     const encryptedResID = localStorage.getItem('restauresID');
  //     const encryptedType = localStorage.getItem('restype');
  //     if (encryptedData && encryptedStatusCode && encryptedResID && encryptedType) {
  //       const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //       const bytes1 = CryptoJS.AES.decrypt(encryptedStatusCode, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //       const bytes2 = CryptoJS.AES.decrypt(encryptedResID, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //       const bytes3 = CryptoJS.AES.decrypt(encryptedType, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //       const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
  //       const decryptedStatusCode = bytes1.toString(CryptoJS.enc.Utf8);
  //       const decryptedResID = bytes2.toString(CryptoJS.enc.Utf8);
  //       const decryptedType = bytes3.toString(CryptoJS.enc.Utf8);
  //       setUserId(decryptedUserId);
  //       setStatusCode(decryptedStatusCode);
  //       setRestaurantId(decryptedResID);
  //       setType(decryptedType);
  //     }
  //   }, [statusCode, userid, restaurantid, type]); // Empty dependency array ensures this runs only once
 
 console.log(statusCode);
  return (
    <div>
      <Layout />
      <ContainerWrap>
   
        <Route exact path="/app_dashboard" component={Dashboard} />
        <Route
          path="/restaurant/meal"
          render={() => (statusCode === '1'
        && permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.view === 1 ? (
          <Meal />
        ) : (
          <AccessDeniedPage />
        ))}
        />

        <Route
          path="/restaurant/request"
          render={() => (statusCode === '1' && permissionsAccess?.[1]?.master_id === '2'
          && permissionsAccess?.[1]?.view === 1 ? (
            <RequestList />
          ) : (
            <AccessDeniedPage />
          ))}
        />
        <Route
          path="/restaurant/resRejectedRequest"
          render={() => (statusCode === '1' && permissionsAccess?.[1]?.master_id === '2'
          && permissionsAccess?.[1]?.view === 1 ? (
            <RejectedRequest />
          ) : (
            <AccessDeniedPage />
          ))}
        />




        <Route
          path="/restaurant/restaurant"
          render={() => (statusCode === '1' && permissionsAccess?.[0]?.master_id === '1'
          && permissionsAccess?.[0]?.view === 1 ? (
            <Restaurant />
          ) : (
            <AccessDeniedPage />
          ))}
        />  
        <Route
          path="/usermanager/users"
          render={() => (statusCode === '1' && type === '0' ? (
            <Users />
          ) : (
            <AccessDeniedPage />
          ))}
        />
        <Route
          path="/usermanger/management"
          render={() => (statusCode === '1' && type === '0' ? (
            <UsersManagement />
          ) : (
            <AccessDeniedPage />
          ))}
        />
        <Route
          path="/restaurant/booking"
          render={() => (statusCode === '1' && permissionsAccess?.[2]?.master_id === '3'
          && permissionsAccess?.[2]?.view === 1 ? (
            <Booking />
            ) : (
              <AccessDeniedPage />
              ))}
        /> 

        {/* for Account        */}
        <Route
          path="/restaurant/account"
          render={() => (statusCode === '1' && permissionsAccess?.[3]?.master_id === '4'
          && permissionsAccess?.[3]?.view === 1 ? (
            <Account />
            ) : (
              <AccessDeniedPage />
              ))}
        />   
        <Route
          path="/restaurant/accountapproved"
          render={() => (statusCode === '1' && permissionsAccess?.[3]?.master_id === '4'
          && permissionsAccess?.[3]?.view === 1 ? (
            <ApprovedAccount />
            ) : (
              <AccessDeniedPage />
              ))}
        />   
        <Route
          path="/restaurant/accountrequest"
          render={() => (statusCode === '1' && permissionsAccess?.[3]?.master_id === '4'
          && permissionsAccess?.[3]?.view === 1 ? (
            <RequestAccount />
            ) : (
              <AccessDeniedPage />
              ))}
        />   
        <Route
          path="/restaurant/accountrejectrequest"
          render={() => (statusCode === '1' && permissionsAccess?.[3]?.master_id === '4'
              && permissionsAccess?.[3]?.view === 1 ? (
                <RejectAccount />
                ) : (
                  <AccessDeniedPage />
                  ))}
        />   
      </ContainerWrap>
    </div>
);
};

// region STYLES

const ContainerWrap = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  background: ${colorBackgroundBody};

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;

// endregion
